import { extendTheme, theme as ChakraTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  colors: {
    blue: {
      100: "#C1EDF5",
      900: "#2b2d42",
    },

    red: {
      50: "#FA738B",
      100: "#fc6dab",
    },

    lilac: {
      100: "#e0c1f5",
    },

    fonts: {
      heading: "Inter",
      body: "Inter",
    },

    fontSizes: {
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
      "6xl": "3.75rem",
      "7xl": "4.5rem",
      "8xl": "6rem",
      "9xl": "8rem",
    },

    styles: {
      global: {
        body: {
          bg: "white",
          color: "gray.900",
        },
      },
    },

    breakpoints: {
      md: "768px",
    },
  },
});
